import { FC, PropsWithChildren } from 'react';
import { Box, IconButton, Popover as MuiPopover, PopoverProps, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    title?: string;
    closeIcon?: React.ReactNode;
    onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, reason: 'backdropClick' | 'escapeKeyDown' | 'closeButtonClick') => void;
};

export const Popover: FC<PropsWithChildren<PopoverProps & Props>> = ({ title, closeIcon, children, ...props }) => {
    return (
        <MuiPopover {...props}>
            <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', maxHeight: '100%' }}>
                <Box sx={{ display: 'flex', mb: 2, gap: 1 }}>
                    <Typography variant='h6'>{title}</Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <IconButton onClick={(e) => props.onClose?.(e, 'closeButtonClick')} size='small' aria-label='close'>
                        {closeIcon ?? <CloseIcon fontSize='small' />}
                    </IconButton>
                </Box>
                {children}
            </Box>
        </MuiPopover>
    );
};
